import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { Table, Select } from 'antd';
import Loading from '$app/shared/components/Loading';
import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';
import { getCapacities, updateCapacity } from './actions';

import EditableCell, { EditableFormRow } from '../../components/EditableCellRow';
import { Segments } from './constants';

import './styles.scss';

const { Option } = Select;

const cols = [
  {
    key: 'day',
    title: 'Date',
    dataIndex: 'day',
    render: (record) => moment(record).format('YYYY-MM-DD, ddd'),
    width: '25%',
  },
  {
    key: 'capacity',
    title: 'Max capacity',
    dataIndex: 'capacity',
    width: '25%',
    editable: true,
  },
  {
    key: 'potentialLoad',
    title: 'Bookings',
    dataIndex: 'potentialLoad',
    width: '25%',
  },
  {
    key: 'available',
    title: 'Available slots',
    dataIndex: 'available',
    width: '25%',
  },
];

export function CapacityPage() {
  const [state, setState] = useState({
    selectedSegment: 'FIXTER-UK',
    loading: true,
    capacities: [],
  });

  useEffect(() => {
    async function getCapacitiesForSegment(segment) {
      const res = await getCapacities(segment);

      const capacities = Array.from(Object.keys(res[segment].days), (key) => {
        res[segment].days[key].day = key;
        return res[segment].days[key];
      });

      setState((st) => ({ ...st, capacities }));
    }

    getCapacitiesForSegment(state.selectedSegment);
  }, [state.selectedSegment]);

  async function updateDayCapacity(capacity) {
    const newCapacity = await updateCapacity(state.selectedSegment, Number(capacity.capacity), capacity.day);
    const { capacities } = state;
    const indexOfDay = capacities.findIndex((cap) => cap.day === capacity.day);
    capacities[indexOfDay] = newCapacity;
    setState((st) => ({ ...st, capacities }));
  }

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const columns = cols.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: updateDayCapacity,
      }),
    };
  });

  function handleOnChange(otherSegment) {
    setState((st) => ({ ...st, selectedSegment: otherSegment }));
  }

  if (state.capacities.length === 0) return <Loading />;

  return (
    <Container style={{ height: window.innerHeight }}>
      <Header style={{ display: 'flex' }}>
        <Title>Capacity</Title>
        <div style={{ marginRight: 0, marginLeft: 'auto' }}>
          <span>Segment</span>
          <Select
            title="Segment"
            defaultValue={Segments.FixterUK}
            style={{ width: 200, paddingLeft: 5 }}
            onChange={handleOnChange}
          >
            <Option value={Segments.FixterUK}>United Kingdom 🇬🇧</Option>
            <Option value={Segments.FixterFR}>France 🇫🇷</Option>
          </Select>
        </div>
      </Header>
      <Table
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        scroll={{ y: window.innerHeight }}
        size="small"
        rowKey={() => Math.random().toString(36)}
        pagination={false}
        dataSource={state.capacities}
        columns={columns}
      />
    </Container>
  );
}

export default withRouter(CapacityPage);
